
  import { Vue, Prop, Component, Emit } from "vue-property-decorator";
  import PostListItem from "@/components/PostListItem.vue";
  import PostSelected from "@/components/PostSelected.vue";
  import FormReplyToAd from "@/components/FormReplyToAd.vue";
  import FormEmailToFriend from "@/components/FormEmailToFriend.vue";
  import { IAdsModel } from "@/models";
  import infiniteScroll from "vue-infinite-scroll";

  @Component({
    name: "PostList",
    components: {
      FormEmailToFriend,
      FormReplyToAd,
      PostSelected,
      PostListItem
    },
    directives: { infiniteScroll }
  })
  export default class PostList extends Vue {
    @Prop({ default: [] }) ads!: IAdsModel[];
    selectedAd: IAdsModel = {} as IAdsModel;
    @Prop({ default: "" }) searchText!: string;
    @Prop({ default: false }) isLazyLoading!: boolean;
    @Prop({ default: false }) isLoading!: boolean;
    @Prop({ default: false }) isAdmin: boolean;
    @Emit("loadmore")
    onLoadMore() {
      // empty function
    }

    onLazyLoading() {
      if (this.ads.length > 0) {
        this.onLoadMore();
      }
    }

    getSelectedAd(value: any) {
      this.selectedAd = value;
    }

    onCallbackReplyEmail(success: boolean) {
      this.$bvModal.hide("reply-to-ad");
      if (success) {
        this.$modal.show("Email has been sent successfully", "success");
      } else {
        this.$modal.show("Failed sent email", "error");
      }
    }
    onCallbackSendEmail(success: boolean) {
      this.$bvModal.hide("email-to-friend");
      if (success) {
        this.$modal.show("Email has been sent successfully", "success");
      } else {
        this.$modal.show("Failed sent email", "error");
      }
    }
    makeToast(title: string, content: string): void {
      this.$bvToast.toast(content, {
        title: title,
        autoHideDelay: 5000
      });
    }

    printSelectedAd(value: any) {
      this.selectedAd = value;
      setTimeout(() => {
        this.$htmlToPaper("printcontainer", () => {
          this.$bvModal.hide("print-ad");
        });
      }, 1000);
    }
    get search() {
      return this.searchText;
    }
  }
